var prongHorn = prongHorn || {};

prongHorn.deliverypopup = prongHorn.deliverypopup || function() {
    var popupTriggerButtons = $('.product-delivery-time__button');

    this.init = function() {
        if(popupTriggerButtons.length) {
            popupTriggerButtons.on('click',function(event) {
                event.preventDefault();
                event.stopPropagation();

                var modalElement = null;

                if($(this).hasClass('product-delivery-time__button--list')) {
                    var commonParentClass = '.product-list-item';
                    modalElement = $(this).closest(commonParentClass).find('.js-modal-delivery-dates');
                }else {
                    modalElement = $('#modalContainerDeliveryDates').find('.js-modal-delivery-dates');
                }
                prepareTableHTML(modalElement);
                $(modalElement).modal('show');
            });
        }
    };

    this.prepareTableHTML = function(modalElement) {
        if(modalElement.hasClass('js-html-has-been-modified')) {
            return;
        }
        modalElement.find('table').each(function(elTable){
            var headers=[];
            $(this).find('tr').each(function(elRow){
                $(this).find('th, td').each(function(elCell){
                    if(elRow === 0) {
                        headers.push($(this).html())
                    }else{
                        $(this).attr('data-header',headers[elCell])
                    }
                });
            });
        })
        modalElement.addClass('js-html-has-been-modified')
    };


    // Public functions
    return {
        init: init
    };

}();

